module.exports = __webpack_public_path__ + "static/media/NFSB04.88d2da36.jpg";